import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import RegisterForm from '../components/RegisterForm';
import { Button, FormGroup } from 'reactstrap';
import WebsiteNotificationBar from '../components/WebsiteNotificationBar';
import { useDispatch } from 'react-redux';
import { registerRequest } from '../actions/User';
import doneRequest from '../Res/Icon/doneRequest.png';
import Spinner from '../components/Spinner/Spinner';
import WarningModal from '../components/WarningModal';
import { ReactComponent as EpikLogoSvg } from '../Res/granite-logo.svg';
import CaptchaForm from './captchaForm';

const AccountRequest = (props) => {
  const dispatch = useDispatch();

  const [userData, setUserData] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [warning, setWarning] = useState(false);
  const [invalidObject, setInvalidObject] = useState({});
  const [warningMessage, setWarningMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpenWarningModal, setIsOpenWarningModal] = React.useState(false);
  const [captchaData, setCaptchaData] = useState({
    sessionId: '',
    csrfToken: '',
    answer: ''
  });

  const handleSubmit = async () => {
    if (userData) {
      setWarning(false)
      const emptyCheck = Object?.entries(userData)?.reduce((acc, [key, value]) => {
        if ((value === null || value?.length === 0) && key !== "phone") {
          acc[key] = true;
        }
        return acc;
      }, {});
      setLoading(true);
      if (Object.values(emptyCheck).length) {
        // Error: Please fill all the fields;
        setInvalidObject(emptyCheck);
      } else {
        setInvalidObject(emptyCheck);
        const payload = {
          name: userData.username,
          email: userData.email.toLowerCase(),
          phone: userData.phone,
          company: userData.companyName,
          customerID: userData.customerId,
          is3rdPartyAgent: userData.is3rdPartyAgent,
          answer:captchaData?.answer ? captchaData?.answer : '',
          sessionId:captchaData?.sessionId ? captchaData?.sessionId : ''
        }
        const result = await dispatch(registerRequest(payload,captchaData?.csrfToken));
        if (result?.success) {
          setSubmitted(true);
        } else {
          setWarning(true)
          setWarningMessage(`Error: ${result?.message || "Something went wrong"}`);
        }
      }

    } else {
      setWarning(true)
      setWarningMessage("Warning: Please fill all the fields");
    }
    setLoading(false);
  }

  const userExist = () => {
    return (
      <div>
        <label style={{ fontSize: '12px', textAlign: 'center', color: 'red', margin: 0 }}>Your request cannot be processed, an email has been sent to your account. If you need help logging in, please click the <Link to="/reset-password" style={{ color: '#8998ac' }}>
          Forgot Password</Link> link.</label>
      </div>
    )
  }

  const onSubmitClick = () => {
    if (userData?.is3rdPartyAgent) {
      setIsOpenWarningModal(true);
      return;
    }

    handleSubmit();
  };

  const onConfirmWarningModal = () => {
    handleSubmit();
    setIsOpenWarningModal(false);
  };

  const onCancelWarningModal = () => {
    setIsOpenWarningModal(false);
  };

  return (
    <div className="container main-container" style={{ marginTop: '45px' }}>
      {
        loading ? <Spinner /> : null
      }
      <div className="register-container">
        <div className="col-12 d-flex align-self-start">
          <EpikLogoSvg width={120} height={60} />
        </div>
        <div className="col-12 text-left" style={{ marginTop: '30px', minHeight: '50vh' }}>
          <h5>Granite EPIK Portal - Customer Account Request</h5>
          {
            !submitted ?
              (
                <p style={{ color: '#8998ac' }}>Please enter your details.</p>
              ) : null
          }
          {
            submitted ?
              <div className='m-4 d-flex justify-content-center align-items-center flex-column '>
                <img
                  className="request-done"
                  src={doneRequest}
                  alt="delete"
                />
                <p style={{ fontSize: '18px', textAlign: 'center', color: '#8998ac' }}>Your account request has been submitted. Please wait for the admin to approve your request.</p>
              </div> :
              <div style={{ position: 'relative', paddingTop: warning ? '50px' : 0 }}>
                <WebsiteNotificationBar isOpen={warning} >
                  {warningMessage === "Error: User already exists" ? userExist() : warningMessage}
                </WebsiteNotificationBar>
                <RegisterForm invalidObject={invalidObject} setUserData={setUserData} />
                <CaptchaForm onCaptchaChange={setCaptchaData}/>
                <FormGroup>
                  <Button color="primary" onClick={onSubmitClick} className="otp-buttons">
                    Submit
                  </Button>
                </FormGroup>
              </div>
          }
        </div>
        <div className="col-12 d-flex">
          <Link to="/login" style={{ color: '#8998ac' }}>
            Login
          </Link>
        </div>
      </div>
      {isOpenWarningModal && (
        <WarningModal
          isOpen={isOpenWarningModal}
          onConfirm={onConfirmWarningModal}
          onCancel={onCancelWarningModal}
          title="3rd Party Authorization"
          noButtonText="No"
          yesButtonText="Yes"
          body='I acknowledge that I have received authorization from this Granite-EPIK Customer Account
          as an approved 3rd party agent.'
        />
      )}
    </div>
  );
}

export default AccountRequest;
